document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarTiempoMuertoSoplado') {
        
        const botonActivo = e.submitter;
        if (!botonActivo || botonActivo.id !== 'btnEditarTiempoMuertoSoplado') {
            return;
        }

        e.preventDefault();
        
        const formulario = e.target;
        const modalPadre = formulario.closest('.modal');
        const spinner = formulario.querySelector('#spinner');
        const btnEditar = formulario.querySelector('#btnEditarTiempoMuertoSoplado'); // Localizamos dentro del form

        if (!formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        const formData = new FormData(formulario, botonActivo);

        btnEditar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(input => input.classList.remove('inputRojo'));

        try {
            const respuesta = await fetch('/api/soplado/editar-tiempo-muerto', {
                method: 'POST',
                body: formData
            });

            const json = await respuesta.json();
            const status = respuesta.status;
            const resultado = json.result;
            

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud, contacta al Administrador.");
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
            } else {
                // ÉXITO
                const idReporteInput = formulario.querySelector('#idEncabezadoReporteSoplado');
                const idReporte = idReporteInput ? idReporteInput.value : null;
                
                const params = new URLSearchParams(window.location.search);
                const mes = params.get("mes");
                const año = params.get("año");

                if (modalPadre) modalPadre.classList.remove('modal--show');
                
                lanzarAlerta("Registro editado con éxito.", "alerta-verde");
                
                // Actualizar vistas sin recargar
                if (typeof window.actualizarModalReporteSoplado === 'function' && idReporte) {
                    window.actualizarModalReporteSoplado(idReporte);
                }
                
                if (typeof window.actualizarTableroSopladoPeriodo === 'function') {
                    window.actualizarTableroSopladoPeriodo(mes, año);
                    window.actualizarTablaSopladoPeriodo(mes, año);
                }
                if (typeof window.actualizarZonaTrabajo === 'function') {
                    if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
                }
            }

        } catch (error) {
            console.error("Error:", error);
            alert("Error crítico al procesar la solicitud, contactar al Administrador.");
        } finally {
            if (btnEditar) btnEditar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    }
});